<template>
  <div class="card-base" v-loading="isLoading">
    <div class="widget-header ph-20 pt-20 pb-20">
      <div class="flex justify-center align-center">
        <div class="widget-info box grow text-truncate animated fadeInLeft">
          <h5>
            {{ title }}
            <el-link @click="loadDocumentation('dashboard-insights')" :underline="false">
              <i class="material-icons">help_outline</i>
            </el-link>
          </h5>
          <line-chart-js
              :chart-id="'1'"
              :chart-data="kpiChartInsights.chartData"
              :chart-options="summaryInfoLineChartOptions"
              style="position: relative; max-width: 150px; max-height: 85px"
          ></line-chart-js>
        </div>
        <div class="widget-info pb-60 box flex column text-truncate animated fadeInRight">
          <h2 class="box self-flex-end light-bold">{{ kpiInsightsRate.toFixed(2) }}</h2>
          <span class="box self-flex-end body1">{{ rateUnits }}</span>
        </div>
      </div>
      <div class="box grow">
        <slot name="additional-info"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import {registerInverval, destroyInverval} from '@/utilities/global.interval'

import {DASHBOARD_KPI_INTERVAL} from '@/constants/polling-interval.constants'
import {DASHBOARD_KPI_REQ} from '@/store/modules/dashboard/kpi-statistics.type'

import LineChartJs from '@/components/chart/LineChartJs.vue'

export default {
  name: 'DashboardInsightsWidget',
  mixins: [loadDocumentationMixin],
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    type: {
      type: String,
      default: () => {
        return ''
      }
    },
    rateUnits: {
      type: String,
      default: () => {
        return ''
      }
    },
    statusKey: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      isLoading: false,
      decommissionableAgents: 0,
      kpiChartInsights: {},
      kpiInsightsRate: 0,
      kpiInsightsIntervalId: {}
    }
  },
  mounted() {
  },
  created() {
    if (_.isEmpty(this.kpiInsightsIntervalId)) {
      this.isLoading = true
      this.fetchKPI()
    }
  },
  methods: {
    pollFetchKPI() {
      this.kpiInsightsIntervalId = setTimeout(() => {
        this.fetchKPI()
      }, DASHBOARD_KPI_INTERVAL)

      registerInverval(this.kpiInsightsIntervalId)
    },
    fetchKPI(command) {
      if (this.kpiInsightsIntervalId) {
        destroyInverval(this.kpiInsightsIntervalId)
      }
      if (this.type) {
        Promise.all([this.$store.dispatch(DASHBOARD_KPI_REQ, this.type)]).then(
            apiResponses => {
              this.kpiChartInsights = apiResponses[0]

              if (this.kpiChartInsights.chartData.datasets) {
                this.kpiChartInsights.chartData.datasets[0].backgroundColor = undefined
                this.kpiChartInsights.chartData.datasets[0].borderColor = undefined
                this.kpiChartInsights.chartData.datasets[0].borderWidth = undefined
                this.kpiChartInsights.chartData.datasets[0].pointRadius = 0 // removes point styling

                let recordCount = this.kpiChartInsights.chartData.datasets[0].data.length
                this.kpiInsightsRate = this.kpiChartInsights.chartData.datasets[0].data[recordCount - 1] / 60
              }
              this.isLoading = false
              this.pollFetchKPI()
            },
            errMsg => {
              this.pollFetchKPI()
            }
        )
      }
    }
  },
  computed: {
    ...mapGetters(['usersListStatus']),
    summaryInfoLineChartOptions() {
      return {
        hover: {
          mode: 'nearest',
          intersect: false
        },
        tooltips: {
          enabled: true,
          displayColors: false,
          mode: 'nearest',
          intersect: false
        },
        elements: {
          point: {pointStyle: false, hitRadius: 0, backgroundColor: "rgba(0, 112, 249)"},
          line: {
            fill: true,
            backgroundColor: 'rgb(242, 248, 255)',
            borderColor: 'rgb(0, 112, 249)'
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                maxTicksLimit: 6
              },
              type: 'time',
              time: {
                // unit: "millisecond",
                tooltipFormat: 'h:mm:ss a'
              }
            }
          ]
        }
      }
    }
  },
  beforeDestroy() {
    // kill interval calls
    this.pollFetchKPI = function () {
    }
    destroyInverval(this.kpiInsightsIntervalId)
  },
  components: {
    LineChartJs
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.card-base {
  height: inherit;
}

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: calc(100% - 20px);
  margin-left: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
}

span {
  margin-left: 10px;
  font-weight: normal;

  &.ml-20 {
    margin-left: 20px;
  }

  &.ml-0 {
    margin-left: 0px;
  }
}

.host-widget-info {
  background-color: var(--aluminum-100);
  padding: 10px;

  &.at-risk {
    background-color: var(--denim-50);
  }

  .widget-title {
    font-weight: 600;
  }

  .widget-count {
    font-size: 1.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardInsightsWidget.vue